import React from "react";
import Icon from "components/AppIcon";

export default function KPICard({ title, value, change, changeLabel, icon, trend, prefix, suffix }) {
  const isPositive = change >= 0;
  const trendColor = trend === "neutral" ?"text-yellow-500"
    : isPositive
    ? "text-emerald-600" :"text-red-500";
  const trendBg = trend === "neutral" ?"bg-yellow-50"
    : isPositive
    ? "bg-emerald-50" :"bg-red-50";

  return (
    <div className="card-base flex flex-col gap-3 min-w-0">
      <div className="flex items-center justify-between">
        <span className="text-xs font-caption font-medium text-muted-foreground uppercase tracking-wide truncate pr-2">
          {title}
        </span>
        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-muted flex-shrink-0">
          <Icon name={icon} size={16} color="var(--color-primary)" />
        </div>
      </div>
      <div className="flex items-end justify-between gap-2">
        <div className="min-w-0">
          <p className="font-heading font-bold text-xl md:text-2xl text-foreground truncate">
            {prefix}{value}{suffix}
          </p>
          <p className="text-xs font-caption text-muted-foreground mt-0.5">{changeLabel}</p>
        </div>
        <div className={`flex items-center gap-1 px-2 py-1 rounded-full flex-shrink-0 ${trendBg}`}>
          <Icon
            name={trend === "neutral" ? "Minus" : isPositive ? "TrendingUp" : "TrendingDown"}
            size={12}
            color={trend === "neutral" ? "#EAB308" : isPositive ? "#059669" : "#DC2626"}
          />
          <span className={`text-xs font-caption font-semibold ${trendColor}`}>
            {isPositive && change !== 0 ? "+" : ""}{change}%
          </span>
        </div>
      </div>
    </div>
  );
}